import { useT } from 'apprise-frontend-core/intl/language'
import { useRegisteredModules } from 'apprise-frontend-tags/tag/provider'
import { useCallback } from 'react'
import type { IconType } from 'react-icons'


export type TaggedModule = {

    Icon?: IconType
    type: string
    singular: string
    plural: string
    customProperties?: string[]
    
}



export const useTagModules = () => {

    const state = useRegisteredModules()

    const t = useT()

    const allModules = state.get().all

    // eslint-disable-next-line
    const sortedModules = useCallback( () => [...allModules].sort((m1,m2) => t(m1.singular).localeCompare(m2.singular)), [allModules] )

    const self = {

        register: (module: TaggedModule) => {
            state.set(s => s.all.push(module))
            return self;
        }

        ,

        lookup: (type: string) => state.get().all.find(m=>m.type===type)
        
        ,

        all: sortedModules

    }

    return self;
}